/* Trailer state inspector. Off unless you ask for it.

   Add ?fxtest to any page on the store and a small panel appears bottom left
   showing what the site currently believes about the customer's trailer, and
   letting you put it into any state without hunting for a real VIN.

   WHY THIS EXISTS. Two separate keys decide whether the progress rail advances
   and whether the header shows "My Trailer": lastSearchedTrailer, written by
   the app extension on a VIN match only, and fxTrailerPick, written by the
   theme when someone commits a model in the chip selector. They have to agree
   and there was no way to check that without clearing site data by hand
   between every test.

   It writes localStorage and nothing else. No network, no cookies, no cart.
   Stage 2 needs a real cart line, because the cart is the server's business
   and faking it would prove nothing.

   Delete this file and the one line that loads it in sections/fx-steps.liquid
   to remove it entirely. */
(function () {
  if (window.location.search.indexOf('fxtest') === -1) return;

  var VIN_KEY = 'lastSearchedTrailer';
  var PICK_KEY = 'fxTrailerPick';

  function read(key) {
    try {
      var raw = window.localStorage.getItem(key);
      return raw ? JSON.parse(raw) : null;
    } catch (e) { return null; }
  }

  function write(key, value) {
    try {
      if (value === null) window.localStorage.removeItem(key);
      else window.localStorage.setItem(key, JSON.stringify(value));
    } catch (e) { /* private window */ }
  }

  function announce() {
    document.dispatchEvent(new CustomEvent('fx:trailer-changed'));
  }

  function cartCount() {
    var bubble = document.querySelector('#cart-icon-bubble .cart-count-bubble');
    if (!bubble) return 0;
    var span = bubble.querySelector('span:not([class])') || bubble.querySelector('span');
    var n = span ? parseInt(String(span.textContent).replace(/\D/g, ''), 10) : NaN;
    return isNaN(n) ? 1 : n;
  }

  function railState() {
    var steps = document.querySelectorAll('.vin-hero-info .vin-hero-step');
    if (!steps.length) return 'no rail on this page';
    var out = [];
    for (var i = 0; i < steps.length; i++) {
      out.push((i + 1) + ':' + (steps[i].getAttribute('data-fx-step') || '?'));
    }
    return out.join('  ');
  }

  function buttonState() {
    var shell = document.querySelector('.fx-shell');
    if (!shell) return 'no header';
    if (!shell.classList.contains('has-vin')) return 'hidden';
    var tag = document.querySelector('.fx-hdr [data-fx-vin-tag]');
    return 'showing “' + (tag ? tag.textContent : '') + '”';
  }

  function expected() {
    var vin = read(VIN_KEY);
    var pick = read(PICK_KEY);
    if (cartCount() > 0) return 'stage 2, step 3 current';
    if ((vin && (vin.vinNumber || vin.modelName)) ||
        (pick && (pick.modelName || pick.rangeName))) {
      return 'stage 1, step 2 current';
    }
    return 'stage 0, step 1 current';
  }

  var panel, body;

  function refresh() {
    if (!body) return;
    var vin = read(VIN_KEY);
    var pick = read(PICK_KEY);
    body.innerHTML =
      row('VIN record', vin ? (vin.vinNumber || vin.modelName || 'set') : 'none') +
      row('Model pick', pick ? (pick.modelName || 'set') : 'none') +
      row('Cart', cartCount() + ' item' + (cartCount() === 1 ? '' : 's')) +
      row('Expected', expected()) +
      row('Rail says', railState()) +
      row('Button says', buttonState());
  }

  function row(k, v) {
    return '<div style="display:flex;gap:10px;padding:3px 0">' +
      '<span style="color:#9A9A9A;flex:0 0 88px">' + k + '</span>' +
      '<span style="color:#fff;font-weight:600">' + v + '</span></div>';
  }

  function button(label, fn) {
    var b = document.createElement('button');
    b.type = 'button';
    b.textContent = label;
    b.style.cssText = 'font:inherit;font-size:12px;font-weight:700;color:#1D1D1F;' +
      'background:#fff;border:0;border-radius:8px;padding:7px 10px;cursor:pointer';
    b.addEventListener('click', function () {
      fn();
      announce();
      window.setTimeout(refresh, 120);
    });
    return b;
  }

  function build() {
    panel = document.createElement('div');
    panel.style.cssText = 'position:fixed;left:16px;bottom:16px;z-index:2147483000;' +
      'width:320px;max-width:calc(100vw - 32px);background:#1D1D1F;color:#fff;' +
      'border-radius:14px;padding:14px 16px 12px;font:400 13px/1.45 -apple-system,' +
      'BlinkMacSystemFont,"Segoe UI",Helvetica,Arial,sans-serif;' +
      'box-shadow:0 18px 44px rgba(0,0,0,.4)';

    var head = document.createElement('div');
    head.style.cssText = 'display:flex;align-items:center;justify-content:space-between;' +
      'margin-bottom:10px';
    head.innerHTML = '<b style="font-size:12px;letter-spacing:.1em;text-transform:uppercase;' +
      'color:#ED2225">Trailer state</b>';

    var x = document.createElement('button');
    x.type = 'button';
    x.textContent = '×';
    x.setAttribute('aria-label', 'Close');
    x.style.cssText = 'font:inherit;font-size:18px;line-height:1;color:#9A9A9A;' +
      'background:none;border:0;cursor:pointer;padding:0 2px';
    x.addEventListener('click', function () { panel.remove(); });
    head.appendChild(x);

    body = document.createElement('div');

    var acts = document.createElement('div');
    acts.style.cssText = 'display:flex;flex-wrap:wrap;gap:6px;margin-top:12px';
    acts.appendChild(button('Nothing searched', function () {
      write(VIN_KEY, null);
      write(PICK_KEY, null);
    }));
    acts.appendChild(button('Picked by model', function () {
      write(VIN_KEY, null);
      write(PICK_KEY, {
        modelName: 'Super Sport',
        modelYear: '2025',
        rangeName: 'Sport Range',
        timestamp: new Date().toISOString()
      });
    }));
    acts.appendChild(button('Searched by VIN', function () {
      write(PICK_KEY, null);
      write(VIN_KEY, {
        vinNumber: '04178',
        modelName: 'Super Sport',
        timestamp: new Date().toISOString()
      });
    }));

    var note = document.createElement('p');
    note.style.cssText = 'margin:10px 0 0;font-size:12px;color:#9A9A9A';
    note.textContent = 'Stage 2 needs a real item in the cart. Reload after ' +
      'switching if the page was rendered before the change.';

    panel.appendChild(head);
    panel.appendChild(body);
    panel.appendChild(acts);
    panel.appendChild(note);
    document.body.appendChild(panel);

    refresh();
    window.setInterval(refresh, 1200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', build);
  } else {
    build();
  }
})();
